const REQUEST_EVENT = 'nsRequestGlobalStore';
const SUPPLY_EVENT = 'nsSupplyGlobalStore';

/**
 * Broadcast a request for the global data store, listen for the response,
 * and return the store supplied within.
 *
 * @returns {Object} The global data store.
 */
export function requestStore() {
  let store;

  document.addEventListener(
    SUPPLY_EVENT,
    ({ detail = {} }) => {
      store = detail.store;
    },
  );

  document.dispatchEvent(new CustomEvent(REQUEST_EVENT));

  if (! store) {
    throw new Error('Unable to obtain global store.');
  }

  return store;
}

/**
 * Listen for broadcasted requests for the global data store, and supply one.
 *
 * @param {Object} store The global data store.
 */
export function supplyStore(store) {
  document.addEventListener(
    REQUEST_EVENT,
    () => {
      document.dispatchEvent(new CustomEvent(
        SUPPLY_EVENT,
        {
          detail: { store },
        },
      ));
    },
  );
}
